/*
 * Module for the multiple member update 
*/
rs.module("content/employer/reporting/maintenance/multiplememberupdate",

    ["controls/components/event-banner"],

    function (eventBanner) {

        var _executeSelectionChanged;

        // Initialize the module
        function initialize(jsSelectors, grid, selectionLimit) {

            // Unpack form js selectors
            var submitButton = $.js(jsSelectors.submitButton);

            // Enforce ValueCountLimit on grid members.
            // i.e. Since we can't send more than the supplied selection limit, disable posting above that number.
            grid.selectionChanged(function (values, rows) {

                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (_executeSelectionChanged) {

                    // If greater than the supplied selection limit, disable delete and add event message.
                    if (grid.selectedValues.length >= selectionLimit) {
                        eventBanner.addErrorMessages("Up to " + $.format.number(selectionLimit, "#,##0") + " records may be selected at one time.");
                        submitButton.setDisabled();
                    }
                    else {
                        eventBanner.removeErrorMessages();
                        submitButton.setDisabled(false);
                    }
                }

                _executeSelectionChanged = true;
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);